<template>
  <div>
    <!-- 客户设置消息 -->
    <el-dialog :title="$t('message.customerMessageSettings')" :close-on-click-modal="false"
      :visible.sync="dialogVisible" width="788px" center>
      <div class="content">
        <!--选择客户聊天群组  -->
        <div class="item" v-if="isAdd">
          <!-- 选择客户 -->
          <el-button type="primary" @click="chooseCWGroup">{{ $t("message.chooseCustomer") }}</el-button>
          <div class="table">
            <ol>
              <!-- 客户ID -->
              <li>
                {{ $t("message.clientID") }}
              </li>
              <!-- 客户名称 -->
              <li>
                {{ $t("message.customerName") }}
              </li>
              <!-- 操作 -->
              <li>
                {{ $t("message.operation") }}
              </li>
            </ol>
            <ul v-for="(item, index) in user" :key="item.id">
              <!-- 客户ID -->
              <li>
                {{ item.id }}
              </li>
              <!-- 客户名称 -->
              <li>
                {{ item.realname }}
              </li>
              <!-- 操作 -->
              <li>
                <!-- 删除 -->
                <el-button type="danger" @click="user.splice(index, 1)" size="mini">{{ $t("message.delete")
                }}</el-button>
              </li>
            </ul>
          </div>
        </div>

        <div class="item" v-for="(item, index) in remarkList" :key="index">
          <!-- 询货消息设置 -->
          <div class="label">
            {{ item.type_name }}
            <span class="switch">
              是否发送消息 <el-switch v-model="item.is_enabled">
              </el-switch>
            </span>
          </div>
          <div class="val">
            <el-input v-model="item.message" onfocus="this.select()" type="textarea"
              placeholder="发送内容 交易号：{purchase_no}"></el-input>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <!-- 保存 -->
        <el-button type="primary" @click="purchaseMessageClientBatchAdd" v-if="isAdd">{{
          $t("message.save")
        }}</el-button>
        <!-- 保存 -->
        <el-button type="primary" @click="purchaseMessageClientUpdate" v-else>{{
          $t("message.save")
        }}</el-button>
      </span>
    </el-dialog>
    <!-- 选择客户聊天群组 -->
    <el-dialog :title="$t('message.chooseCustomerChatGroup')" :close-on-click-modal="false"
      :visible.sync="chooseCWGroupDialogVisible" width="500px" center>
      <div class="content">
        <div class="row">
          <!--  操作类型： -->
          <div class="value">
            <el-input v-model="clientID" :placeholder="$t('message.clientID')"></el-input>
          </div>
          <!-- 查询 -->
          <el-button type="primary" @click="chooseCWGroupSave" style="margin-left: 10px;">{{
            $t("message.inquire")
          }}</el-button>
        </div>
        <div class="table">
          <ol>
            <!-- 客户ID -->
            <li>
              {{ $t("message.clientID") }}
            </li>
            <!-- 客户名称 -->
            <li>
              {{ $t("message.customerName") }}
            </li>
            <!-- 操作 -->
            <li>
              {{ $t("message.operation") }}
            </li>
          </ol>
          <ul v-for="(item, index) in clientList" :key="item.id">
            <!-- 客户ID -->
            <li>
              {{ item.id }}
            </li>
            <!-- 客户名称 -->
            <li>
              {{ item.realname }}
            </li>
            <!-- 操作 -->
            <li>
              <!-- 删除 -->
              <el-button type="danger" @click="clientList.splice(index, 1)" size="mini">{{ $t("message.delete")
              }}</el-button>
            </li>
          </ul>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <!-- 确认 -->
        <el-button type="primary" @click="confirmUser">{{
          $t("message.confirm")
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {

  data() {
    return {
      isAdd: true,
      dialogVisible: false,
      remarkList: [],
      chooseCWGroupDialogVisible: false,
      clientID: "",
      clientList: [],
      user: [],
    };
  },
  methods: {
    // 保存
    purchaseMessageClientBatchAdd() {
      let datas = {
        user_ids: this.user.map(item => item.id),
        configs: [],
      };
      this.remarkList.forEach(item => {
        datas.configs.push({
          type: item.type,
          is_enabled: item.is_enabled ? 1 : 0,
          message: item.message,
        })
      })
      if (this.user.length === 0) {
        this.$message({
          message: this.$t("message.pleaseChooseCustomer"),
          type: "warning",
        });
        return;
      }
      this.$api.orderApi.purchaseMessageClientBatchAdd(datas).then((res) => {
        this.$message.success(res.msg);
        this.dialogVisible = false
        this.$parent.purchaseMessageClientList();
      });
    },
    // 更新
    purchaseMessageClientUpdate() {
      let datas = {
        user_id: this.user[0],
        configs: [],
      };
      this.remarkList.forEach(item => {
        datas.configs.push({
          type: item.type,
          is_enabled: item.is_enabled ? 1 : 0,
          message: item.message,
        })
      })

      this.$api.orderApi.purchaseMessageClientUpdate(datas).then((res) => {
        this.$message.success(res.msg);
        this.dialogVisible = false
        this.$parent.purchaseMessageClientList();
      });
    },
    // 选择客户聊天群组
    chooseCWGroup() {
      this.clientID = "";
      this.clientList = [];
      this.chooseCWGroupDialogVisible = true;
    },
    // 选择客户聊天群组
    chooseCWGroupSave() {
      if (!this.clientID) {
        this.$message({
          message: this.$t("message.pleaseEnterClientID"),
          type: "warning",
        });
        return;
      }
      let datas = {
        user_ids: this.clientID,

      }
      this.$api.orderApi.purchaseMessageClientBatchQueryUsers(datas).then((res) => {
        this.clientList = [...this.clientList, ...res.data];
        // 过滤重复客户
        this.clientList = this.clientList.filter((item, index, arr) => {
          return arr.findIndex((t) => t.id === item.id) === index;
        });
      });
    },
    // 确认客户
    confirmUser() {
      if (this.clientList.length === 0) {
        this.$message({
          message: this.$t("message.pleaseChooseCustomer"),
          type: "warning",
        });
        return;
      }
      this.user = [...this.user, ...this.clientList];
      // 过滤重复客户
      this.user = this.user.filter((item, index, arr) => {
        return arr.findIndex((t) => t.id === item.id) === index;
      });
      this.chooseCWGroupDialogVisible = false;
    },
  },
  watch: {
    dialogVisible(newVal, oldVal) {
      if (newVal && this.isAdd) {
        this.$api.orderApi.purchaseMessageList().then((res) => {
          res.data.forEach(item => {
            item.is_enabled = item.is_enabled == 1 ? true : false
          })
          this.remarkList = res.data

        })
      }
    }
  }
};
</script>
<style lang='scss' scoped>
.content {
  margin: 0px 15px;


  .item {
    margin-bottom: 20px;

    .label {
      display: flex;
      justify-content: space-between;
      margin-bottom: 20px;

      &:last-child {
        margin-bottom: 0px;
      }
    }
  }

  .table {
    margin-top: 24px;
  }

  .row {
    display: flex;
    line-height: 40px;
    margin-bottom: 10px;

    .label {
      margin-right: 20px;
    }

    .value {
      flex: 1;
    }
  }
}

/deep/.el-textarea__inner {
  height: 100px
}
</style>